export function getCurrentKeyword (query, fieldName) {
  return (!query || !query[fieldName] || query[fieldName] === '') ? '' : query[fieldName]
}

export function getCurrentPage (query) {
  return (!query || !query['page'] || query['page'] === '') ? '' : query['page']
}



// WEBPACK FOOTER //
// ./src/utils/queryHelper.js